

const ChargementPieceJointeCollection = function(element) {
    this.element = $(element);
    this.tbody = this.element.find('table tbody');

    this.element.on('click', '[data-add-file]', event => {
        this.addPrototype();

        event.preventDefault();
    });
    this.element.on('click', '[data-delete]', event => {
        this.deleteRow($(event.currentTarget).closest('tr'));
    });
};

$.extend(ChargementPieceJointeCollection.prototype, {
    addPrototype: function() {
        let prototype = this.element.attr('data-prototype'),
            name = parseInt(this.element.attr('data-next-name'));

        prototype = prototype.replace(/__name__/g, name);

        this.element.attr('data-next-name', name + 1);

        this.tbody.append(prototype);
    },

    deleteRow: function(tr) {
        tr.remove();
    }
});

const chargementPieceJointeCollection = () => {
    const selector = 'div[data-chargement-piece-jointe-collection]';

    $(document).arrive(selector, {
        existing: true
    }, function() {
        new ChargementPieceJointeCollection(this);
    });
};

export { chargementPieceJointeCollection }


// WEBPACK FOOTER //
// ./js/form/chargementPieceJointeCollection.js